import { render, staticRenderFns } from "./ModalSuporteVisualizarGrupo.vue?vue&type=template&id=49f9a2df&scoped=true"
import script from "./ModalSuporteVisualizarGrupo.vue?vue&type=script&lang=ts"
export * from "./ModalSuporteVisualizarGrupo.vue?vue&type=script&lang=ts"
import style0 from "./ModalSuporteVisualizarGrupo.vue?vue&type=style&index=0&id=49f9a2df&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49f9a2df",
  null
  
)

export default component.exports